<template>
  <div class="admin-sync-rule-master">
    <section class="top-wrap">
      <div class="main-title">主规则</div>
      <div class="right">
        <div class="mRight10">
          <el-input
            v-model="searchText"
            size="small"
            placeholder="搜索规则名称"
            clearable
            @keyup.native.enter="search"
            @clear="search"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </div>
        <el-button type="primary" size="small" @click="showCreate">新建</el-button>
      </div>
    </section>
    <section class="main-wrap">
      <div v-if="!showTable" v-loading="!showTable" class="empty"></div>
      <base-table
        v-else
        ref="BaseTable"
        :tableHeight="tableHeight"
        :table-columns="masterTableColumns"
        :tableData="filterData"
        :pageInfo="pageInfo"
        from="app"
      >
        <el-table-column
          v-for="(item, index) in masterTableColumns"
          :key="index"
          :prop="item.value"
          :label="item.label"
          :width="item.width"
          :min-width="item.minWidth"
          :align="item.align"
        >
          <template slot-scope="scope">
            <template v-if="item.value === 'enable'">
              <el-tag v-if="!scope.row.enable" type="info" effect="dark" size="mini">
                禁用
              </el-tag>
              <el-tag v-else type="success" effect="dark" size="mini">启用</el-tag>
            </template>
            <template v-else>
              {{ _.get(scope.row, item.value) }}
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="handle" label="操作" width="160">
          <template v-slot="scope">
            <base-button @click="toEdit(scope.row)" type="text" size="mini">
              编辑
            </base-button>
            <base-button @click="switchState(scope.row)" type="text">
              {{ scope.row.enable ? "禁用" : "启用" }}
            </base-button>
            <base-button
              v-if="!scope.row.enable"
              @click="handleDelete(scope.row)"
              type="text"
              size="mini"
            >
              删除
            </base-button>
          </template>
        </el-table-column>
      </base-table>
    </section>
    <save-master-rule-dialog ref="saveMasterRuleDialog" @change="refresh"></save-master-rule-dialog>
  </div>
</template>
<script>
import BaseTable from "@/components/BaseComponents/Table"
import BaseButton from "@/components/UIComponents/Button"
import { masterTableColumns } from "./static"
import TableController from "@/views/Backend/Admin/Layout/mixin/TableController"
import { deleteSyncRuleMaster, getSyncRuleMasterList, enableSyncRuleMaster } from "@/api/connect"
import SaveMasterRuleDialog from "./SaveMasterRuleDialog"

export default {
  name: "admin-sync-rule-master",
  components: { BaseTable, SaveMasterRuleDialog, BaseButton },
  inject: ["app"],
  data() {
    return {
      masterTableColumns,
      ruleList: [],
      filterData: [],
      filterKeys: ["name"],
      pageInfo: {
        total: 1000,
        currentPage: 1,
        pageSize: 20
      },
      searchText: "",
      loadingItems: {
        data: true
      }
    }
  },
  mixins: [TableController],
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      this.loadingItems.data = true
      getSyncRuleMasterList(this.app.id).then(ruleList => {
        this.ruleList = ruleList.map(r => ({
          ...r,
          exportStr: r.export ? "输出" : "接收"
        }))
        this.loadingItems.data = false
        this.filterData = this.ruleList
        this.resetTotal(this.filterData)
      })
    },
    showCreate() {
      this.$refs.saveMasterRuleDialog.open()
    },
    search() {
      this.handleSearch({
        tableData: this.ruleList,
        filterKeys: this.filterKeys,
        searchText: this.searchText
      })
    },
    toEdit(row) {
      this.$refs.saveMasterRuleDialog.open(row)
    },
    switchState(row) {
      enableSyncRuleMaster(row.id, !row.enable).then(() => {
        this.refresh()
        this.$message.success("操作成功")
      })
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        deleteSyncRuleMaster(row.id).then(() => {
          this.refresh()
          this.$message.success("刪除成功")
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.admin-sync-rule-master {
}
</style>
